import React, {Component} from 'react';

import { Button, message, Breadcrumb, DatePicker, Select } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import FundLevelReportGrid from './FundLevelReportGrid';
import FundPositionGroupInfoGrid from './FundPositionGroupInfoGrid';
import moment from 'moment';
import '../../DocumentReport.css';

// const Option = Select.Option;

class FundLevelReportDashboard extends Component {

  state = {
    searchDate: moment(),
    dataType: 'ALL',
    // countryDesc: 'ALL',
    // exchange: 'ALL',
    fundCode: 'All-Funds',
    // qtyType: '',
  };

  

  componentDidMount() {
    this.props.loadExchangeCode('');
    // let searchStr = !!this.props.location ? this.props.location.search : null;
    // let guid = undefined;
    // if(!!searchStr) {
    //     if(searchStr.indexOf('?')  >= 0) {
    //         searchStr = searchStr.substring(searchStr.indexOf('?') + 1);
    //         const searchArray = searchStr.split('&');
    //         for (let i=0; i<searchArray.length; i++) {
    //             const subParamArray = searchArray[i].split("=");
    //             if(!!subParamArray && subParamArray.length > 1 && subParamArray[0] === 'guid') {
    //               guid = subParamArray[1];
    //             }
    //         }
    //     }
    // }
    // const {
    //   searchDate,
    //   dataType,
    // } = this.state;
    
    // this.props.loadFundLevelReport(searchDate.format("YYYY-MM-DD"), dataType,guid);
  }

  componentDidUpdate() {
    const {
      // Load Fund Level Report Action Status
      loadFundLevelReportActionStatus,
      loadFundLevelReportErrMsg,

      // Generate Fund Level Report Action Status
      generateFundLevelReportActionStatus,
      generateFundLevelReportErrMsg,

      listFundPosGroupInfoActionStatus,
      listFundPosGroupInfoActionResp,
    } = this.props;

   const {
      searchDate,
      countryDesc,
      exchange,
      fundCode,
      dataType,
      qtyType,
    } = this.state;

    // Generate Fund Level Report 成功
    if (generateFundLevelReportActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Short position report are generated successfully!');
      this.props.initGenerateFundLevelReportActionStatus();
      this.props.loadFundLevelReport(searchDate.format("YYYY-MM-DD"), countryDesc, exchange, fundCode, dataType, qtyType);
    }

    // Generate Fund Level Report 失败
    if (generateFundLevelReportActionStatus === ACTION_STATUS.ERROR) {
      message.error(generateFundLevelReportErrMsg);
      this.props.initGenerateFundLevelReportActionStatus();
    }

    // Load Fund Level Report 成功
    if (loadFundLevelReportActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadFundLevelReportActionStatus();
    }

    // Load Fund Level Report 失败
    if (loadFundLevelReportActionStatus === ACTION_STATUS.ERROR) {
      message.error(loadFundLevelReportErrMsg);
      this.props.initLoadFundLevelReportActionStatus();
    }

    if(listFundPosGroupInfoActionStatus === ACTION_STATUS.SUCCESS) {
      if(!listFundPosGroupInfoActionResp || !listFundPosGroupInfoActionResp.data || listFundPosGroupInfoActionResp.data.length === 0) {
        message.warn('No data found. You need to "Generate" first');
      }
      this.props.initListFundPosGroupInfoActionStatus();
    }
    if(listFundPosGroupInfoActionStatus === ACTION_STATUS.ERROR) {
      let errMsg = 'Query Fund Position Report Info failed';
      if(!!listFundPosGroupInfoActionResp && !!listFundPosGroupInfoActionResp.respMessage) {
        errMsg = listFundPosGroupInfoActionResp.respMessage;
      }
      message.error(errMsg);
      this.props.initListFundPosGroupInfoActionStatus();
    }

  }

  searchBtnOnClicked = () => {
    const {
      searchDate,
      countryDesc,
      exchange,
      fundCode,
      dataType,
      qtyType
    } = this.state;

    this.props.loadFundLevelReport(searchDate.format("YYYY-MM-DD"), countryDesc, exchange, fundCode, dataType, qtyType);
  }

  genreateReportBtnOnClicked = () => {
    const {
      searchDate,
      countryDesc,
      exchange,
      fundCode,
      dataType,
      qtyType
    } = this.state;

    this.props.generateFundLevelReport(searchDate.format("YYYY-MM-DD"), countryDesc, exchange, fundCode, dataType, qtyType);
  }

  listFundPosGroupInfo = () => {
    const {
      searchDate,
      countryDesc,
      exchange,
      fundCode,
      dataType,
      qtyType
    } = this.state;

    if(dataType === 'B') {
      message.warn('"EQTY & SWAP" is not supported by "Report"');
      return;
    }

    this.props.listFundPosGroupInfo(searchDate.format("YYYY-MM-DD"), countryDesc, exchange, fundCode, dataType, qtyType);
  }


  showAllBtnOnClicked = () => {
    this.props.showAllFundLevelReport();
  }


  exportAsXls = () => {
    const {
      gridType,
      fundLevelReportGrid,
      fundPositionGroupInfoGrid,
    } = this.props;
    const grid = gridType === 1 ? fundLevelReportGrid : fundPositionGroupInfoGrid;
    const fileName = gridType === 1 ? 'fund_position_detail.xlsx' : 'fund_position_summary_report.xlsx';
    grid.api.exportDataAsExcel({fileName});
}

  
  render() {
    const {
      countryCodeOptions,
      exchageCodeOptions,
      // Generate Fund Level Report Action Status
      generateFundLevelReportActionStatus,
      loadFundLevelReportActionStatus,
      listFundPosGroupInfoActionStatus,
      gridType,
    } = this.props;

    const {
      searchDate,
      fundCode,
      countryDesc,
      exchange,
      dataType,
      qtyType
    } = this.state;

    const generateBtnIsLoading = generateFundLevelReportActionStatus === ACTION_STATUS.LOGINING;
    const loadBtnIsLoading = loadFundLevelReportActionStatus === ACTION_STATUS.LOGINING;
    const listFundPosGroupInfoBtnIsLoading = listFundPosGroupInfoActionStatus === ACTION_STATUS.LOGINING;

    return (
      <div className="fundLevelReportWrapper">

        <div className='breadcrumbWrapper'>
          <Breadcrumb>
            <Breadcrumb.Item>Document &amp; Report</Breadcrumb.Item>
            <Breadcrumb.Item>Fund Level Report</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        
        <div className='operationBar'>
          <DatePicker 
            style={{ marginLeft: 10, fontSize: 10, width: 150 }}
            size='small'
            allowClear={false}
            value={searchDate}
            onChange={(date, dateString) => {
              this.setState({ 
                  ...this.state,
                  searchDate: date,
              })
            }} 
          />
          <Select
              size='small'
              style={{ marginLeft: 10, fontSize: 10, width: 120 }}
              allowClear={true}
              value={fundCode}
              onChange={(val) => {
                this.setState({
                    ...this.state,
                    fundCode: val,
                })
              }}
          >
            <Select.Option key='All-Funds'>ALL</Select.Option>
            <Select.Option key='PMSF'>PMSF</Select.Option>
            <Select.Option key='PCF'>PCF</Select.Option>
            <Select.Option key='VCC'>VCC</Select.Option>
          </Select>

           <Select
              placeholder="Country" 
              size='small'
              style={{ marginLeft: 10, fontSize: 10, width: 180 }}
              showSearch
              filterOption={(inputValue, option) => {
                  const idx = option.key.toUpperCase().indexOf(inputValue.toUpperCase());
                  return idx !== -1;
              }}
              allowClear={true}
              value={countryDesc}
              onChange={(val) => {
                this.setState({
                    ...this.state,
                    countryDesc: val,
                })
              }}
          >{countryCodeOptions}</Select>

          <Select
              placeholder='Exchange' 
              size='small'
              style={{ marginLeft: 10, fontSize: 10, width: 260 }}
              showSearch
              filterOption={(inputValue, option) => {
                  const idx = option.key.toUpperCase().indexOf(inputValue.toUpperCase());
                  return idx !== -1;
              }}
              allowClear={true}
              value={exchange}
              onChange={(val) => {
                this.setState({
                    ...this.state,
                    exchange: val,
                })
              }}
          >{exchageCodeOptions}</Select>

           <Select
              placeholder='Asset' 
              size='small'
              style={{ marginLeft: 10, fontSize: 10, width: 150 }}
              allowClear={false}
              value={dataType}
              onChange={(val) => {
                this.setState({
                    ...this.state,
                    dataType: val,
                })
              }}
          >
            <Select.Option key='ALL'>ALL</Select.Option>
            <Select.Option key='A'>EQTY</Select.Option>
            <Select.Option key='C'>SWAP</Select.Option>
            <Select.Option key='D'>Future</Select.Option>
            <Select.Option key='F'>OPTION</Select.Option>
            <Select.Option key='E'>Currency</Select.Option>
            <Select.Option key='G'>Fixed Income</Select.Option>
          </Select>

           <Select
              placeholder='PosnType' 
              size='small'
              style={{ marginLeft: 10, fontSize: 10, width: 150 }}
              allowClear={true}
              value={qtyType}
              onChange={(val) => {
                this.setState({
                    ...this.state,
                    qtyType: val,
                })
              }}
          >
            <Select.Option key='ALL'>ALL</Select.Option>
            <Select.Option key='GROSS'>GROSS</Select.Option>
            <Select.Option key='LONG'>LONG</Select.Option>
            <Select.Option key='NET'>NET</Select.Option>
            <Select.Option key='SHORT'>SHORT</Select.Option>
          </Select>

          <Button 
            onClick={this.searchBtnOnClicked} 
            size='small'
            loading={loadBtnIsLoading}
            type='primary'>
            Search
          </Button>

          <Button 
            onClick={this.genreateReportBtnOnClicked} 
            size='small'
            loading={generateBtnIsLoading}
            type='primary'>
            Generate
          </Button>

          <Button 
            onClick={this.listFundPosGroupInfo} 
            size='small'
            loading={listFundPosGroupInfoBtnIsLoading}
            type='primary'>
            Report
          </Button>

        </div>

        <div className='fundLevelReportGrid'>
          {
            gridType === 1
            ? <FundLevelReportGrid {...this.props} />
            : <FundPositionGroupInfoGrid {...this.props} />
          }
        </div>

      </div>
    );
  }
}

export default FundLevelReportDashboard;